var map = {
	"./basketballTraining.svg": "3189",
	"./basketballTrainingCol.svg": "2357",
	"./dayoff.svg": "a3b0",
	"./dayoffCol.svg": "299b",
	"./holiday.svg": "b901",
	"./holidayCol.svg": "eb52",
	"./match.svg": "86b1",
	"./matchCol.svg": "a3e5",
	"./meeting.svg": "fbd0",
	"./meetingCol.svg": "6357",
	"./physicalTraining.svg": "e252",
	"./physicalTrainingCol.svg": "22bf",
	"./training.svg": "fbb5",
	"./trainingCol.svg": "c376",
	"./travel.svg": "a033",
	"./travelCol.svg": "ddfc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7fa2";